
export function getNumbers(largeCount, smallCount) {
    let results = [];

    let largeNumbers = [25,50,75,100];
    let numberRands = Array(4).fill(0);
    let numberIndexs = Array(4).fill(0);

    for (let i = 0; i < 4; i++) {
        numberRands[i] = Math.random();
    }
    
    for (let i = 0; i < 4; i++) {
        let maxValue = -1;
        let maxIndex = 0;
        for (let j = 0; j < 4; j++) {
            if (maxValue < numberRands[j]) {
                maxValue = numberRands[j];
                maxIndex = j;
            }
        }
        numberIndexs[i] = maxIndex;
        numberRands[maxIndex] = -1;
    }

    for (let i = 0; i < largeCount; i++) {
        results.push(largeNumbers[numberIndexs[i]]);
    }
    
    for (let i = largeCount; i < largeCount + smallCount; i++) {
        results.push(Math.floor((Math.random() * 10) + 1));
    }

    return results;
}

export function getTargetNumber() {
    let result = 0;

    while (result === 0) {
        let newNumber1 =(Math.floor(Math.random() * 10));
        let newNumber10 =  (Math.floor(Math.random() * 10) * 10);
        let newNumber100 = (Math.floor(Math.random() * 9) * 100);
        let newNumber = 100 + newNumber1 + newNumber10 + newNumber100;
        if (newNumber > 99 && newNumber < 1000) {
            result = newNumber;
        }
    }
    return result;
}

